import { useState, useEffect } from "react";
import axios from "axios";
import { Layers, CreditCard, CheckCircle2, FileText, Cpu, KeyRound, PauseCircle, AlertTriangle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KPIS = [
  { key: "pages_total", label: "Seiten gesamt", icon: Layers, tone: "indigo", id: "total-pages" },
  { key: "active_subs", label: "Aktive Abos", icon: CreditCard, tone: "emerald", id: "active-subs" },
  { key: "pending_approvals", label: "Offene Freigaben", icon: CheckCircle2, tone: "amber", id: "pending-approvals" },
  { key: "content_updates", label: "Offene Content-Updates", icon: FileText, tone: "indigo", id: "content-updates" },
  { key: "ai_calls_today", label: "KI-Aufrufe heute", icon: Cpu, tone: "violet", id: "ai-calls" },
  { key: "password_resets", label: "Passwort-Resets", icon: KeyRound, tone: "amber", id: "password-resets" },
  { key: "failed_domains", label: "Domain-Fehler", icon: AlertTriangle, tone: "rose", id: "failed-domains" },
  { key: "deactivated", label: "Deaktivierte Seiten", icon: PauseCircle, tone: "slate", id: "deactivated" },
];
const TONES = { indigo: "bg-indigo-50 text-indigo-600", emerald: "bg-emerald-50 text-emerald-600", amber: "bg-amber-50 text-amber-600", violet: "bg-violet-50 text-violet-600", rose: "bg-rose-50 text-rose-600", slate: "bg-slate-100 text-slate-600" };

export function AdminOverview({ adminToken, tick }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/overview`, { headers: { Authorization: `Bearer ${adminToken}` } }).then(r => setData(r.data)).catch(() => {});
  }, [adminToken, tick]);
  if (!data) return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-indigo-600" /></div>;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-overview">
      {KPIS.map(k => {
        const Icon = k.icon;
        return (
          <div key={k.key} className="bg-white rounded-xl border border-slate-200 p-5 shadow-[0_2px_8px_rgba(15,23,42,0.04)]" data-testid={`admin-kpi-${k.id}`}>
            <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-3 ${TONES[k.tone]}`}><Icon className="w-5 h-5" /></div>
            <p className="text-3xl font-bold text-slate-900" data-testid={`admin-kpi-value-${k.id}`}>{data[k.key]}</p>
            <p className="text-sm text-slate-500 mt-0.5">{k.label}</p>
          </div>
        );
      })}
    </div>
  );
}
